import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { GoldButton } from "./ui-kit";
import { MessageSquare } from "lucide-react";

export function Layout({ children }) {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <div className="grain min-h-screen relative">
      <Navbar />
      <main className="relative z-[2]">{children}</main>
      <Footer />
      <CookieBanner />
      {/* Mobile sticky CTA */}
      <div className="lg:hidden fixed bottom-4 inset-x-4 z-40">
        <GoldButton to="/devis" className="w-full shadow-2xl" data-testid="mobile-sticky-devis">
          <MessageSquare size={18} /> Demander un devis
        </GoldButton>
      </div>
    </div>
  );
}
